import TemporaryKardiaRxEcgHackedGraph from './TemporaryKardiaRxEcgHackedGraph'

export default TemporaryKardiaRxEcgHackedGraph



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/TemporaryKardiaRxEcgHackedGraph/index.js